/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const FavouriteFill = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 22 20">
      <path
        d="M5.486.846C2.496 1.372.421 4.075.657 7.136c.174 2.264 1.237 4.431 3.306 6.742 1.444 1.612 3.661 3.437 5.827 4.795.761.478.926.553 1.21.553.284 0 .449-.075 1.21-.553 2.929-1.837 5.527-4.17 7.113-6.388 1.652-2.312 2.355-4.851 1.909-6.896A5.873 5.873 0 0 0 16.485.844a6.915 6.915 0 0 0-1.868-.019 5.886 5.886 0 0 0-3.297 1.677l-.322.322-.32-.322A5.88 5.88 0 0 0 7.383.825a7.298 7.298 0 0 0-1.897.021"
        fillRule="evenodd"
      />
    </BaseSvgIcon>
  )
}

export default FavouriteFill
